import type { ReactNode } from 'react';

/** The given phrases, lit wherever the text says them; unmatched phrases stay silent. */
export const highlightMatches = (text: string, phrases: string[]): ReactNode => {
  const usable = phrases.map((phrase) => phrase.trim()).filter((phrase) => phrase.length >= 3);
  if (!usable.length) return text;
  const pattern = usable
    .sort((a, b) => b.length - a.length)
    .map((phrase) => phrase.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/\s+/g, '\\s+'))
    .join('|');
  const parts = text.split(new RegExp(`(${pattern})`, 'gi'));
  if (parts.length === 1) return text;
  return parts.map((part, index) =>
    index % 2 === 1 ? (
      <mark key={index} className='rounded-sm bg-amber-200/80 px-0.5 text-inherit'>
        {part}
      </mark>
    ) : (
      part
    )
  );
};
